var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2573 15.1223C16.2573 16.549 15.0634 17.7056 13.5907 17.7056C12.1179 17.7056 10.924 16.549 10.924 15.1223C10.924 13.6955 12.1179 12.5389 13.5907 12.5389C15.0634 12.5389 16.2573 13.6955 16.2573 15.1223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.257324 9.10612C0.257324 7.328 1.50651 5.77807 3.28718 5.34681L5.59066 4.78894L7.46568 2.0643C7.96026 1.34562 8.79287 0.91394 9.68448 0.91394H17.4968C18.3884 0.91394 19.2211 1.34562 19.7156 2.0643L21.5907 4.78894L23.8941 5.34681C25.6748 5.77807 26.924 7.328 26.924 9.10612V22.8723C26.924 25.0124 25.1331 26.7473 22.924 26.7473H4.25732C2.04818 26.7473 0.257324 25.0124 0.257324 22.8723V9.10612ZM22.924 9.95561C22.924 10.669 22.327 11.2473 21.5907 11.2473C20.8543 11.2473 20.2573 10.669 20.2573 9.95561C20.2573 9.24224 20.8543 8.66394 21.5907 8.66394C22.327 8.66394 22.924 9.24224 22.924 9.95561ZM18.924 15.1223C18.924 17.9757 16.5362 20.2889 13.5907 20.2889C10.6451 20.2889 8.25732 17.9757 8.25732 15.1223C8.25732 12.2688 10.6451 9.95561 13.5907 9.95561C16.5362 9.95561 18.924 12.2688 18.924 15.1223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5959ce681b399e983bdecad288940b56.svg";
export { ForwardRef as ReactComponent };